<template>
  <div></div>
</template>
<script>
import store from '@/store'
import { generateIndexRouter } from '@/utils/util'
import router from '@/router'
import Vue from 'vue'
export default Vue.extend({
  name: 'goApp',
  async created() {
    const { app, tenant } = this.$route.params
    
    if(tenant){
      if(app.url.indexOf('tenantId') === -1){
        if(app.url.indexOf('?') === -1){
          app.url += '?'
        }else{
          app.url += '&'
        }
        app.url += `tenantId=${tenant.id}`
      }
    }
    if (app.url.startsWith('http')) {
      window.location.href = app.url
    } else {
      const { result } = await store.dispatch('GetPermissionList')
      const menuData = result.menu
      if (menuData === null || menuData === '' || menuData === undefined) {
        return
      }
      let constRoutes = []
      constRoutes = generateIndexRouter(menuData)
      store.dispatch('UpdateAppRouter', { constRoutes })
      router.addRoutes(store.getters.addRouters)
        this.$router.replace(`${app.url}`)
      }
  },
})
</script>